<template>
  <div>
    <b-container fluid>
      <tour-map
        ref="tourMap"
        :tour-ids="[this.tour.id]"
        with-tracking
        popup-type="visit"
        style="width: 100%;"
        :handlers="['b']"
        @delete-from-tour="deleteFromTour"
        with-courier
        v-if="this.tour.id"
       />
    </b-container>
    <b-container id="view-tour" v-if="tour">
      <b-row>
        <b-col>
          <b-card>
            <h3>
              <span v-translate="{tourId: tour.id}">Tour <strong>%{tourId}</strong></span>
              <span :title="!notOptimized ? this.$gettext('Optimized Tour 😊') : this.$gettext('This tour has been modified and it IS NOT optimized')" style="display: inline-block; width: 1.1em; height:1.1em; border-radius: 100px; line-height: 1; vertical-align: text-top;" :class="tour.status === 'DRAFT' ? 'bg-danger' : (!notOptimized ? 'bg-success' : 'bg-warning')"></span>
            </h3>
            <h4 v-if="tour.label && tour.label !== 'Moova'" v-translate="{tourLabel: tour.label}">Label: <strong>%{tourLabel}</strong></h4>
            <div v-else>
              <img src="/static/img/moova-blue.svg" class="d-block mt-1" style="max-width: 150px;" alt="">
            </div>
            <p v-if="tour.applied_by">
              <translate>Applied by:</translate>
              <b-link :to="{name: 'UsersEdit', params: {id: tour.applied_by.id}}" target="_blank">#{{tour.applied_by.id}}</b-link>
              <strong>{{tour.applied_by.name}}</strong>
            </p>
            <hr>
            <b-alert variant="warning" :show="tour.status !== 'DRAFT' && notOptimized && !tour.reprocess">
              <h4 v-translate>This tour has been modified and it IS NOT optimized</h4>
              <b-button variant="warning" @click="optimizeTour" v-translate>Resend to Routifier!</b-button>
            </b-alert>
            <b-alert variant="warning" :show="tour.reprocess === 1">
              <h4 v-translate>This tour has been modified and it's currently being re-routed</h4>
              <p v-translate>Please, wait a minute and reload the page until it's finished.</p>
            </b-alert>
            <b-row>
              <b-col md="7">
                <h2>
                  <span v-translate="{tourStatus: tour.status}">Status: <strong>%{tourStatus}</strong></span>
                  <small v-if="waiting">(WAITING)</small>
                </h2>
                <p v-translate="{lastUpdated: moment.utc(tour.updated_at).tz($tz).format('L LT')}">Last updated: <strong>%{lastUpdated}</strong></p>
              </b-col>
              <b-col class="text-right">
                <b-button variant="secondary" size="lg" v-b-modal.modalVisitsOverview :disabled="tour.status === 'DRAFT' || visits4Show.length === 0" v-translate>Visits Overview</b-button>
              </b-col>
            </b-row>
            <div v-if="tour.shippings && tour.shippings.length > 0">
              <b-row>
                <b-col v-if="tour.courier_id !== null">
                  <hr class="mt-0">
                  <h4>
                    <translate>Current Courier</translate>
                    <b-button variant="danger" size="sm" @click="unassignTour" v-if="tour.courier_id !== null && noVisitsYet && tour.status !== 'FINISHED' && tour.status !== 'CANCELED'" v-translate>UNASSIGN Tour</b-button>
                  </h4>
                  <user-card :user="tour.courier" profile-picture-size="90px" />
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
        <b-col cols="3" class="text-right" v-if="tour.status !== 'DRAFT' && tour.status !== 'FINISHED' && tour.status !== 'CANCELED'">
          <br>
          <b-button block variant="info" @click="optimizeTour" v-translate>Force resend to Routifier!</b-button>
          <div>
            <br>
            <b-button block v-b-modal.modalAssignNormal variant="secondary" :disabled="tour.status !== 'READY' || tour.courier_id !== null" v-translate>
              Assign Courier
            </b-button>

            <b-modal id="modalAssignNormal" ref="modalAssignNormal" hide-footer @hide="newCourier = null">
              <template #modal-title><translate>Assign Courier</translate></template>
              <template #modal-header-close><img src="@/assets/img/ic_close.svg" alt="×" /></template>
              <div class="form-group">
                <label for="search-courier" v-translate>Search for courier by name or email</label>
                <user-autocomplete ref="courierAc" @selected="onSearchCourierSelected" :restrictToRoles="['courier']" with-picture />
              </div>
              <b-row v-if="newCourier">
                <user-card :user='newCourier' profile-picture-size="90px" />
                <b-col cols="12" class="text-right">
                  <b-button @click="assignCourier" v-translate>Assign!</b-button>
                </b-col>
              </b-row>
            </b-modal>

          </div>
          <br>
          <br>
          <b-button block variant="danger" @click="cancelTour" v-if="tour.status !== 'CANCELED'" v-translate>CANCEL Tour</b-button>
        </b-col>
      </b-row>
    </b-container>
    <b-container>
      <b-row>
        <b-col cols="12">
          <b-card>
            <h3>
              <translate>Comments</translate>
              <b-button size="sm" style="padding: 0.1rem 1rem;" @click.prevent="newComment = null" v-b-modal.modalAddComment v-if="tour.status !== 'FINISHED' && tour.status !== 'CANCELED'" v-translate>
                Add a comment
              </b-button>
              <b-button size="sm" style="padding: 0.1rem 1rem;" variant="danger" @click.prevent="deleteComment" v-if="tour.comment && tour.status !== 'FINISHED' && tour.status !== 'CANCELED'" v-translate>
                Delete ALL comments
              </b-button>
            </h3>
            <div v-html="$options.filters.brize(tour.comment)" v-if="tour.comment"></div>
            <div v-else v-translate>
              No comments yet.
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-container>

    <b-modal ref="modalAddComment" id="modalAddComment" hide-footer>
      <template #modal-title><translate>Assign Courier</translate></template>
      <template #modal-header-close><img src="@/assets/img/ic_close.svg" alt="×" /></template>
      <form @submit.stop.prevent="addComment">
        <b-row>
          <b-col cols="12" class="form-group">
            <b-form-textarea v-model="newComment" required></b-form-textarea>
          </b-col>
          <div class="form-group col-12 form-actions">
            <b-button type="submit" :disabled="!newComment" v-translate>
              Send Comment
            </b-button>
            <b-button variant="outline-secondary" @click.prevent="$refs.modalAddComment.hide()" v-translate>
              Cancel
            </b-button>
          </div>
        </b-row>
      </form>
    </b-modal>

    <b-container id="view-tour" v-if="shippings.length > 0">
      <h3 v-translate>Manage Tour Shippings</h3>
      <b-card v-if="tour.status !== 'FINISHED' && tour.status !== 'CANCELED'">
        <form @submit.prevent="addShippingToTour">
          <b-row>
            <b-col lg="4">
              <label for="add-shipping" v-translate>Shipping IDs (one per line)</label>
              <b-form-textarea rows="3" max-rows="6" id="add-shipping" v-model="newShippings" required></b-form-textarea>
            </b-col>
            <b-col lg="8"><br>
              <b-button variant="secondary" size="sm" type="submit" class="align-self-center" v-translate>Add shipping/s to this Tour</b-button>
            </b-col>
          </b-row>
        </form>
      </b-card>

      <b-card v-for="(shipping, index) in shippings" :key="index" class="shipping-item" :class="shipping.status.toLowerCase()">
        <b-row>
          <b-col cols="12" md="6" lg="3" class="shipping-status mb-3 mb-lg-0" order="1">
            <shipping-statuses class="text-muted" :shipping="shipping" />
            <div>
              <strong class="shipping-id"><b-link :to="{name: 'ShippingsEdit', params: {id: shipping.id}}" target="_blank">{{shipping.id | uuid }}</b-link><span v-if="shippingSizeName(shipping)"> ({{shippingSizeName(shipping)}})</span></strong><br>
              <span class="shipping-date">{{moment.utc(shipping.created_at).tz($tz).format('L LT')}}</span>
            </div>
            <div v-if="shipping.company">
              <b-badge variant="dark" v-translate>Company</b-badge>
              <small><company-card :company="shipping.company" :profilePicture="false" :withContact="false" /></small>
            </div>

          </b-col>
          <b-col cols="12" md="6" lg="3" class="shipping-origin mb-3 mb-lg-0" order="3" order-lg="2">
            <h5 class="shipping-contact">{{shipping.from_contact}}</h5>
            <p><span class="shipping-address">{{shipping.address_from.formatted_address}}</span>
              <span v-if="(shipping.status !== 'WAITING' && shipping.status !== 'CANCELED') && !isScheduled">
                <br v-if="shipping.from_email || shipping.from_phone">
                {{shipping.from_email}}<br v-if="shipping.from_email">
                {{shipping.from_phone}}
              </span>
            </p>
          </b-col>
          <b-col cols="12" md="6" lg="3" class="shipping-destination mb-3 mb-lg-0" order="4" order-lg="3">
            <h5 class="shipping-contact">{{shipping.to_contact}}</h5>
            <p><span class="shipping-address">{{shipping.address_to.formatted_address}}</span>
              <span v-if="(shipping.status !== 'WAITING' && shipping.status !== 'CANCELED') && !isScheduled">
                <br v-if="shipping.to_email || shipping.to_phone">
                {{shipping.to_email}}<br v-if="shipping.to_email">
                {{shipping.to_phone}}
              </span>
            </p>
          </b-col>
          <b-col cols="12" md="6" lg="3" class="shipping-actions text-right ml-n5 mb-3 mb-lg-0 align-self-center" style="padding-left: 35px;" order="2" order-lg="4">
            <b-button v-show="shipping.company && shipping.status !== 'PICKEDUP' && shipping.status !== 'INTRANSIT' && shipping.status !== 'DELIVERED' && shipping.status !== 'CANCELED' && shipping.status !== 'RETURNED'" variant="outline-danger" size="sm" @click.stop.prevent="deleteFromTour(tour, shipping)" class="shipping-list-item-cancel align-self-center" v-translate>DELETE from this Tour</b-button>
          </b-col>
        </b-row>
      </b-card>
    </b-container>

    <b-modal id="modalVisitsOverview" size="lg" ref="modalVisitsOverview" hide-footer>
      <template #modal-title><translate>Visits Overview</translate></template>
      <template #modal-header-close><img src="@/assets/img/ic_close.svg" alt="×" /></template>
      <b-card v-for="(visit, index) in visits4Show" :key="index" :class="visit.visited === 1 ? 'bg-success text-light' : ''">
        <b-row>
          <b-col cols="1">
            <h2>{{index + 1}}</h2>
          </b-col>
          <b-col cols="11">
            <shipping-visit :visit="visit" with-ids />
          </b-col>
        </b-row>
      </b-card>
    </b-modal>

    <b-modal id="modalDeleteFromTour" ref="modalDeleteFromTour" hide-footer @hide="deleteType = null">
      <template #modal-title><translate>Assign Courier</translate></template>
      <template #modal-header-close><img src="@/assets/img/ic_close.svg" alt="×" /></template>
      <form @submit.stop.prevent="deleteFromTour">
        <div class="form-group col-12">
          <b-form-radio-group v-model="deleteType" name="deleteType" required>
            <b-form-radio value="A"><translate>Mark as READY and DELETE (Op must manage the shipping again later)</translate></b-form-radio>
            <b-form-radio value="B"><translate>Mark as WAITING and DELETE (the system will find and assign the shipping to the best courier option immediately)</translate></b-form-radio>
          </b-form-radio-group>
        </div>
        <b-row>
          <div class="text-center form-group col-12 form-actions">
            <b-button type="submit" variant="danger" :disabled="!deleteType" v-translate>Delete!</b-button>
            <b-button type="button" variant="outline-secondary" @click.prevent="$refs.modalDeleteFromTour.hide()" v-translate>Cancel</b-button>
          </div>
        </b-row>
      </form>
    </b-modal>

  </div>
</template>

<script>
import {
  TourService,
  ShippingService,
  FixedPriceService
} from '@/services/api'
import ToursMixin from '@/mixins/tours.mixin'
import AddressesMixin from '@/mixins/address.mixin'
import DataTransformersMixin from '@/common/dataTransformers'
import UserAutocomplete from '@/components/Autocompletes/UserAutocomplete'
import AddressAutocomplete from '@/components/Autocompletes/AddressAutocomplete'
import ShippingVisit from '@/components/Shippings/Visit'
import ShippingStatuses from '@/components/Shippings/Statuses'
import TourMap from '@/components/Maps/TourMap'

export default {
  name: 'ToursEdit',
  title() {
    return this.$gettextInterpolate(this.$gettext('Tour #%{tourId}'), { tourId: this.$options.filters.uuid(this.$route.params.id) })
  },
  components: {
    UserAutocomplete,
    AddressAutocomplete,
    ShippingVisit,
    ShippingStatuses,
    TourMap
  },
  data() {
    return {
      tour: {},
      visits: [],
      shippings: [],
      visits4Show: [],
      searchQuery: '',
      selectedSearchItem: null,
      newCourier: null,
      notOptimized: false,
      isScheduled: null, // FAKE
      newShippings: null,
      toDelete: {},
      deleteType: null,
      start_location: {},
      addressAcInput: '',
      waiting: false,
      forceReroute: false,
      newComment: null
    }
  },
  computed: {
    courierCredits() {
      return this.tour.account_transactions.filter(x => x.relationship === 'provider' && x.type === 'credit')
        .map(x => Number.parseFloat(x.amount))
        .reduce((total, num) => total + num, 0)
    },
    courierDebits() {
      return this.tour.account_transactions.filter(x => x.relationship === 'provider' && x.type === 'debit')
        .map(x => Number.parseFloat(x.amount))
        .reduce((total, num) => total + num, 0)
    },
    courierProfit() {
      return this.formatNumber(this.courierCredits - this.courierDebits)
    },
    clientCredits() {
      return this.tour.account_transactions.filter(x => x.relationship === 'client' && x.type === 'credit')
        .map(x => Number.parseFloat(x.amount))
        .reduce((total, num) => total + num, 0)
    },
    clientDebits() {
      return this.tour.account_transactions.filter(x => x.relationship === 'client' && x.type === 'debit')
        .map(x => Number.parseFloat(x.amount))
        .reduce((total, num) => total + num, 0)
    },
    clientCost() {
      return this.formatNumber(this.clientDebits - this.clientCredits)
    },
    ourProfit() {
      return this.formatNumber(this.clientCost - this.courierProfit)
    },
    noVisitsYet() {
      return !this.visits.some(x => x.visited === 1)
    }
  },
  mixins: [
    AddressesMixin,
    ToursMixin,
    DataTransformersMixin
  ],
  mounted() {
    this.getTour()
  },
  methods: {
    addComment() {
      const payload = {
        comment: this.$store.getters.profile.name + ' (' + this.moment.utc().tz(this.$tz).format('L LT') + ' ' + (!this.$cookies.get('bypassCountry') ? window.country : 'UTC') + ')\n' + this.newComment + '\n\n' + (this.tour.comment || '')
      }

      TourService.update(this.$route.params.id, payload)
        .then(response => {
          this.getTour()
          this.$refs.modalAddComment.hide()
        })
    },
    deleteComment() {
      if (
        confirm(this.$gettext('Are you sure you want to DELETE ALL the comments on this Tour?'))
      ) {
        const payload = {
          comment: null
        }

        TourService.update(this.$route.params.id, payload)
          .then(response => {
            this.getTour()
          })
      }
    },
    addCourier(courierData) {
      const currentPlace = {
        geometry: {
          location: {
            lat: function () {
              return Number.parseFloat(courierData.lat)
            },
            lng: function () {
              return Number.parseFloat(courierData.lng)
            }
          }
        }
      }
      this.$refs.fullMap.setPlace(currentPlace)
      this.$refs.fullMap.addMarker(courierData.icon, courierData.id, courierData.x, courierData.y, courierData.infoText)
    },
    async getTour() {
      this.$store.dispatch('showSpinner')
      const params = {
        includes: [
          'visits',
          'shippings.company',
          'shippings.to_area.regions',
          'courier.courier_available.tracking',
          'fixed_amount_price_schedules.fixed_tour',
          'account_transactions'
        ]
      }
      return await TourService.get(this.$route.params.id, { params })
        .then(response => {
          if (this.dataTransformers.tours) {
            if (this.dataTransformers.tours.transform) {
              response.body = this.dataTransformers.tours.transform(response.body)
            }
          }
          this.tour = response.data
          this.visits = this.tour.visits
          this.shippings = this.tour.shippings

          // Vroom Project JSON export for use on http://map.vroom-project.org/
          if (this.tour.shippings && this.tour.shippings.length > 0) {
            console.log(JSON.stringify(
              {
                vehicles: [
                  {
                    id: 2,
                    start: [
                      Number.parseFloat(this.tour.shippings[0].address_from.lng),
                      Number.parseFloat(this.tour.shippings[0].address_from.lat)
                    ],
                    capacity: [
                      40
                    ],
                    skills: [
                      2,
                      14
                    ],
                    time_window: [
                      1600416000,
                      1600430400
                    ],
                    breaks: [{
                      id: 2,
                      service: 300,
                      time_windows: [
                        [
                          1600423200,
                          1600425000
                        ]
                      ]
                    }]
                  }
                ],
                shipments: this.tour.shippings.map((x, i) => {
                  return {
                    amount: [1],
                    pickup: {
                      id: i + 1,
                      location: [
                        Number.parseFloat(x.address_from.lng),
                        Number.parseFloat(x.address_from.lat)
                      ],
                      description: x.address_from.formatted_address,
                      service: 300
                    },
                    delivery: {
                      id: i + 1 + 1000,
                      location: [
                        Number.parseFloat(x.address_to.lng),
                        Number.parseFloat(x.address_to.lat)
                      ],
                      description: x.address_to.formatted_address,
                      service: 300
                    }
                  }
                })
              }
            ))
          }

          this.visits4Show = []
          let prevVisit
          response.data.visits.forEach(visit => {
            this.notOptimized = this.notOptimized === true || visit.order === null || false
            if (visit.type + '-' + visit.place_id !== prevVisit) {
              visit.shipping_ids = [visit.shipping_id]
              this.visits4Show.push(visit)
            } else {
              if (visit.visited === 1) {
                this.visits4Show[(this.visits4Show.length - 1)].visited = 1
              }
              this.visits4Show[(this.visits4Show.length - 1)].shipping_ids.push(visit.shipping_id)
            }
            prevVisit = visit.type + '-' + visit.place_id
          })
          this.tour.visits4Show = this.visits4Show

          this.shippings.forEach(shipping => {
            if (shipping.status === 'WAITING' && this.waiting !== true) {
              this.waiting = true
            } else if (shipping.status !== 'WAITING') {
              this.waiting = false
            }
          })

          this.tour.price = this.shippings.reduce(function (a, b) {
            return a + Number.parseFloat(b.price)
          }, 0)
          this.tour.commission = this.tour.fixed_amount_price_schedules[0] && this.tour.fixed_amount_price_schedules[0].status !== 'canceled'
            ? Number.parseFloat(this.tour.fixed_amount_price_schedules[0].amount)
            : this.shippings.reduce(function (a, b) {
              return a + Number.parseFloat(b.courier_commission)
            }, 0)

          this.$store.dispatch('hideSpinner')
          // this.$refs.tourMap.fetchTours()
        })
    },
    reloadTour() {
      this.$nextTick(() => {
        this.getTour()
      })
    },
    onSearchCourierSelected(item) {
      this.newCourier = item
      this.$refs.courierAc.searchQuery = ''
    },
    assignCourier() {
      if (
        confirm(this.$gettext('Are you sure you want to ASSIGN the current tour to the selected courier?'))
      ) {
        TourService.update(this.$route.params.id, { courier_id: this.newCourier.id })
          .then(response => {
            this.reloadTour()
            this.$refs.modalAssignNormal.hide()
          })
      }
    },
    async unassignTour() {
      if (
        confirm(this.$gettext('Are you sure you want to UNASSIGN the current courier of the tour?'))
      ) {
        if (this.tour.fixed_amount_price_schedules[0]) {
          await this.deleteFixedPrice()
        }
        TourService.unassignCourier(this.$route.params.id)
          .then(response => {
            this.notOptimized = false
            this.reloadTour()
          })
      }
    },
    async deleteFixedPrice() {
      return FixedPriceService.delete(this.tour.fixed_amount_price_schedules[0].id)
    },
    optimizeTour() {
      if (
        confirm(this.$gettext('Are you sure you want to RESEND the current tour to Routifier?'))
      ) {
        this.$store.dispatch('showSpinner')
        TourService.generateRoute(this.$route.params.id, this.start_location)
          .then(response => {
            this.notOptimized = false
            this.reloadTour()
          })
      }
    },
    setTourAsReady() {
      if (
        confirm(this.$gettext('Are you sure you want to reset this tour as READY?'))
      ) {
        for (const shipping of this.tour.shippings) {
          const params = {
            shipping_id: shipping.id,
            user_id: this.$store.getters.profile.id,
            status: 'READY'
          }
          let n = 0

          ShippingService.changeStatus(params)
            .then(response => {
              n++
              if (n === this.tour.shippings.length) {
                this.getTour()
              }
            })
        }
      }
    },
    cancelTour() {
      if (
        confirm(this.$gettext('Are you sure you want to CANCEL the current tour?'))
      ) {
        TourService.cancelTour(this.$route.params.id)
          .then(response => {
            this.notOptimized = false
            this.reloadTour()
          })
      }
    },
    addShippingToTour() {
      const newShippings = this.newShippings.split('\n').filter(Boolean)
      if (
        confirm('Are you sure you want to ADD this/these ' + newShippings.length + ' shipping/s to the current Tour?')
      ) {
        TourService.addShippings(this.$route.params.id, newShippings)
          .then(response => {
            this.notOptimized = false
            this.newShippings = null
            this.reloadTour()
          })
      }
    },
    async selectedFrom(item) {
      await this.checkPlace(item)
      this.$nextTick(() => {
        if (this.theCheckedAddress.id) {
          this.addressAcInput = this.theCheckedAddress.formatted_address
          this.start_location = {
            lat: this.theCheckedAddress.lat,
            lng: this.theCheckedAddress.lng
          }
        }
        this.theCheckedAddress = {}
      })
    },
    fixedPriceSuccess() {
      setTimeout(function () {
        this.getTour()
        this.$refs.modalFixedPrice.hide()
      }.bind(this), 1000)
    },
    fixedPriceCancel() {
      this.$refs.modalFixedPrice.hide()
    },
    recalculateBudget() {
      if (
        confirm(this.$gettext('Are you sure you want to RECALCULATE currently active Tour shippings\' Budgets?'))
      ) {
        TourService.recalculateBudget(this.tour.id)
          .then(response => {
            this.getTour()
          })
      }
    },
    shippingSizeName(shipping) {
      return this.shippingSizes.find(x => x.id === shipping.size_id)?.name || null
    }
  }
}
</script>
